// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"McHM83","titleValue":"l3xFJy","block":"EueS6I","isOpen":"pWmXBB","title":"_25pIC4","icon":"PAdK7p","list":"oB0lkc"};